"use strict";

exports.__esModule = true;
exports["default"] = exports.stateGetters = void 0;

var React = _interopRequireWildcard(require("react"));

var _validatorjs = _interopRequireDefault(require("validatorjs"));

var _underscore = _interopRequireDefault(require("underscore"));

var _focusOnFirstError = _interopRequireDefault(require("./focusOnFirstError"));

var _isAPromise = _interopRequireDefault(require("./isAPromise"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var stateGetters = {
  // $FlowFixMe
  "default": function _default(oldValue, e) {
    return e.target.value;
  },
  tinymce: function tinymce(oldValue, e) {
    return e.target.getContent();
  },
  select: function select(oldValue, e) {
    return e;
  },
  date: function date(oldValue, e) {
    return e;
  },
  passthrough: function passthrough(oldValue, e) {
    return e;
  },
  checkbox: function checkbox(oldValue, e) {
    return e.target.checked;
  },
  stacked_table: function stacked_table(previouslySelected, value, checked) {
    previouslySelected = previouslySelected || [];

    if (checked) {
      return previouslySelected.concat(value);
    } else {
      return previouslySelected.filter(function (id) {
        return id !== value;
      });
    }
  }
};
exports.stateGetters = stateGetters;

var defaultFieldValues = function defaultFieldValues(options, props) {
  return typeof options.initialValues === 'function' ? options.initialValues(props) : Object.assign({}, options.initialValues);
};

var wrappedForm = function wrappedForm(options) {
  return function (ComponentClass) {
    var _class, _temp;

    var name = ComponentClass.displayName || ComponentClass.name || 'Component';
    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(_class, _React$Component);

      function _class(_props) {
        var _this;

        _this = _React$Component.call(this, _props) || this;

        _this.updateValue = function (fieldName, stateGetterName) {
          if (stateGetterName === void 0) {
            stateGetterName = 'default';
          }

          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            // https://reactjs.org/docs/events.html#event-pooling
            // args[0] is sometimes an event whose target becomes null with async setState calls
            if (args[0] && args[0].persist) {
              args[0].persist();
            }

            _this.setState(function (previousState) {
              var _Object$assign;

              // by default, updateValue uses the 'default' state setter, which
              // corresponds to input tags where the value lives at event.target.value
              // by default, we assign the state value to e.target.value
              // updateValue lets you provide a different format function reference if
              // the state you need to persist lives at a different place
              var functionToGrabInputValue = stateGetters[stateGetterName];
              var oldValue = previousState.fields[fieldName];
              var newValue = functionToGrabInputValue.apply(void 0, [oldValue].concat(args));
              return {
                fields: Object.assign({}, previousState.fields, (_Object$assign = {}, _Object$assign[fieldName] = newValue, _Object$assign))
              };
            });
          };
        };

        _this.updateValues = function (fields) {
          _this.setState(function (previousState) {
            return {
              fields: Object.assign({}, previousState.fields, fields)
            };
          });
        };

        _this.setFormErrors = function (errors, shouldFocusOnFirstError) {
          if (shouldFocusOnFirstError === void 0) {
            shouldFocusOnFirstError = true;
          }

          _this.setState({
            errors: errors
          }, function () {
            shouldFocusOnFirstError && _this.focusOnFirstError();
          });
        };

        _this.removeFormError = function (errorPath) {
          _this.setState(function (previousState) {
            var errors = _extends({}, previousState.errors);

            delete errors[errorPath];
            return {
              errors: errors
            };
          });
        };

        _this.resetFormState = function () {
          _this.setState({
            fields: defaultFieldValues(options, _this.props),
            errors: {},
            formError: null
          });
        };

        _this.focusOnFirstError = function () {
          var rootElement = _this.formWrapperRefOverride || _this.formWrapperRef;

          if (rootElement) {
            (0, _focusOnFirstError["default"])(rootElement);
          }
        };

        _this.validateForm = function () {
          var rules = typeof options.validationRules === 'function' ? options.validationRules({
            props: _this.props,
            fields: _this.state.fields
          }) : options.validationRules || {};
          var errorMessages = typeof options.validationErrorMessages === 'function' ? options.validationErrorMessages({
            props: _this.props,
            fields: _this.state.fields
          }) : options.validationErrorMessages || {};
          var validation = new _validatorjs["default"](_this.state.fields, rules, errorMessages);
          return validation;
        };

        _this.wrapSubmit = function (callback) {
          return function (event) {
            event.preventDefault();

            if (_this.state.isSubmitting) {
              return;
            }

            var validation = _this.validateForm();

            if (!validation.passes()) {
              if (options.onValidationFailure) {
                options.onValidationFailure();
              }

              var _errors = validation.errors.errors;

              _this.setFormErrors(_errors);

              return;
            }

            _this.setState({
              errors: {}
            }); // Forms that return a Promise get automatic protection from double-submits


            var promise = callback(event);

            if (!promise || !(0, _isAPromise["default"])(promise)) {
              return;
            }

            _this.setState({
              isSubmitting: true
            }, function () {
              promise["finally"](function () {
                _this.setState({
                  isSubmitting: false
                });
              });
            });
          };
        };

        _this.payloadTransformer = function (fields, props) {
          if (options.mapFieldsToPayload) {
            return options.mapFieldsToPayload({
              fields: fields,
              props: props
            });
          }

          return Object.assign({}, fields);
        };

        _this.formPayload = function () {
          return _this.payloadTransformer(_this.state.fields, _this.props);
        };

        _this.isDirty = function () {
          var initialFields = defaultFieldValues(options, _this.props);

          var initialPayload = _this.payloadTransformer(initialFields, _this.props);

          return !_underscore["default"].isEqual(initialPayload, _this.formPayload());
        };

        _this.setFormWrapperRefOverride = function (el) {
          _this.formWrapperRefOverride = el;
        };

        _this.state = {
          fields: defaultFieldValues(options, _props),
          errors: {},
          formError: null,
          isSubmitting: false
        };
        return _this;
      }

      var _proto = _class.prototype;

      _proto.componentDidMount = function componentDidMount() {
        var customRules = typeof options.customValidationRules === 'function' ? options.customValidationRules() : options.customValidationRules || {};
        Object.keys(customRules).forEach(function (rule) {
          _validatorjs["default"].register(rule, customRules[rule]);
        });

        if (typeof options.configureValidator === 'function') {
          options.configureValidator();
        }
      };

      _proto.render = function render() {
        var _this2 = this;

        return /*#__PURE__*/React.createElement("span", {
          ref: function ref(el) {
            return _this2.formWrapperRef = el;
          }
        }, /*#__PURE__*/React.createElement(ComponentClass, _extends({}, this.props, {
          formFields: this.state.fields,
          formErrors: this.state.errors,
          isSubmitting: this.state.isSubmitting,
          updateValue: this.updateValue,
          updateValues: this.updateValues,
          setFormErrors: this.setFormErrors,
          removeFormError: this.removeFormError,
          wrapSubmit: this.wrapSubmit,
          resetFormState: this.resetFormState,
          formPayload: this.formPayload,
          isDirty: this.isDirty,
          setFormWrapperRefOverride: this.setFormWrapperRefOverride
        })));
      };

      return _class;
    }(React.Component), _class.displayName = "WrappedForm(" + name + ")", _class.wrappedInstance = ComponentClass, _temp;
  };
};

var _default2 = wrappedForm;
exports["default"] = _default2;